export default function LodashService($injector) {
	
	let $window = $injector.get('$window');
	
	/*
	 * ToDo: If Lodash is not available  try to load from another source.
	 */
	if (!$window._) {
		//console.log('Error: Lodash is not available.');
	}

	return $window._;

}
